import {IUserProfileModel} from '../model/appModel';
import profileApi from '../service/profileApi';
import config from '../service/config';
import useSWR from 'swr';

const fetchUserProfile = async (techSmithId: string) => techSmithId ? await profileApi.getUserProfileInfo(techSmithId) : {} as IUserProfileModel;

export const useUserProfileData = () => {
   const tscId = config?.user?.TechSmithId;
   const userProfileId = `UserProfileInfo-${tscId}`;
   const {data, error} = useSWR(userProfileId, () => fetchUserProfile(tscId), {revalidateOnFocus: false});

   return {
      userProfile: data,
      isWorking: !error && !data,
      hasError: error
   };
};
